/**
 * 將資料匯出為 CSV 並下載
 * @param data 資料陣列
 * @param columns 欄位定義 [{key, title}]
 * @param filename 下載檔名
 */
export function exportCsv(
  data: Record<string, any>[],
  columns: { key: string; title: string }[],
  filename: string
) {
  const header = columns.map(c => c.title).join(',');
  const rows = data.map(row =>
    columns.map(c => {
      const val = row[c.key];
      if (val === null || val === undefined) return '';
      const str = String(val);
      // Escape quotes and wrap in quotes if contains comma/newline/quote
      if (str.includes(',') || str.includes('\n') || str.includes('"')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    }).join(',')
  );
  const csv = [header, ...rows].join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
